import * as React from 'react';
import { Dispatch } from 'redux';
import './Register.less';
import { Form, Row, Col, Button, Input, message, Select } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { FormComponentProps } from 'antd/lib/form';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import UserAction, { updateUserError } from 'src/redux/UserActions';
import RegisterDTO from 'src/models/account/RegisterDTO';
import { UserState } from 'src/redux/UserReducer';
import FullscreenApi from 'src/utils/FullscreenHelper';
import RoleRedirect from 'src/utils/RoleRedirect';
import { ConstantState } from 'src/redux/ConstantReducer';
import DebugUtil from 'src/utils/DebugUtil';
import { ConfigState } from 'src/redux/ConfigReducer';
import ConfigAction from 'src/redux/ConfigActions';
import Languages from 'src/constants/Languages';
import { Grades } from 'src/constants/Grades';

const logo = require('src/assets/branding/logo.png');

interface RegisterProps extends PageProps<{}>, LocalizeContextProps, FormComponentProps {
  // From Redux
  User: UserState;
  Constants: ConstantState;
  Config: ConfigState;
  register: (registerModel: RegisterDTO) => Promise<boolean>;
  updateUserError: (msg: string) => void;
  clearPreviousLocation: () => void;
}

class Register extends React.Component<RegisterProps> {
  constructor(props: RegisterProps) {
    super(props);
    bindAllOfThis(this, Register.prototype);
  }

  componentWillMount() {
    this.checkUserRegister(this.props);
  }

  componentWillReceiveProps(nextProps: RegisterProps) {
    if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== '') {
      message.error(this.props.translate(nextProps.User.errorMsg));
      this.props.updateUserError('');
    }

    this.checkUserRegister(nextProps);
  }

  private handleRegister(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    // Prevent crushing the register button
    if (this.props.User.state === 'loading') {
      return;
    }

    this.props.form.validateFields((errors, values: RegisterDTO) => {
      // Make sure all fields are filled out
      if (!errors) {
        // Fire the register request
        if (!DebugUtil.isDebugEnabled()) {
          FullscreenApi.RequestFullscreen(document.body);
        }

        this.props.register(values);
      }
    });
  }

  private checkUserRegister(props: RegisterProps) {
    if (props.User.state === 'finished' && props.Constants.state === 'finished') {
      // User is logged in and can be directed to either their homepage, or a redirect page if one is set
      // JB: This will set the language whenever the register page is rendered
      if (this.props.User.cultureCode != null) {
        let language = Languages.FindByCode(this.props.User.cultureCode);
        this.props.setActiveLanguage(language.code);
      }

      let route = RoleRedirect.GetRoleRoute(props.User.roleID, props.User.gradeId);
      if (this.props.Config.previousLocation != null) {
        route = this.props.Config.previousLocation;
        this.props.clearPreviousLocation();
      }

      // With this, we can skip the rendering cost of the register page and just send the user to the proper page
      // Set push to false to remove '/register' from the users history
      return props.history.replace(route);
    }
  }

  render() {
    // Register has been removed so send them back to the login page to have it deal with them
    return (
      <Redirect to={Routes.LOGIN}/>
    );

    return (
      <div>
        <Row type="flex" justify="center">
          <Col xs={22} sm={22} md={18} lg={14} xl={11} className="register-form">
            <Link to={Routes.BASE_ROUTE} className="logo" tabIndex={-1}>
              <img src={logo} alt="Kuder Galaxy" height="100%" width="100%" tabIndex={-1} />
            </Link>
            <Form hideRequiredMark onSubmit={this.handleRegister}>
              <h3>
                <Translate id={'account.register.header1'} />
              </h3>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="firstName">
                  <Translate id="account.register.firstName" />
                </label>
                {this.props.form.getFieldDecorator('firstName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.firstName').toString()}
                    placeholder={this.props.translate('account.register.firstName').toString()}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="lastName">
                  <Translate id="account.register.lastName" />
                </label>
                {this.props.form.getFieldDecorator('lastName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.lastName').toString()}
                    placeholder={this.props.translate('account.register.lastName').toString()}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="email">
                  <Translate id="account.register.email" />
                </label>
                {this.props.form.getFieldDecorator('email', {
                  rules: [
                    { required: true, message: this.props.translate('admin.common.requiredRule').toString() },
                    { pattern: /^.+\@.+\..+$/, message: this.props.translate('admin.common.emailRule').toString() }
                  ]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.email').toString()}
                    placeholder={this.props.translate('account.register.email').toString()}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="stateAbbreviation">
                  <Translate id="account.register.stateAbbreviation" />
                </label>
                {this.props.form.getFieldDecorator('stateAbbreviation', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.stateAbbreviation').toString()}
                    placeholder={this.props.translate('account.register.stateAbbreviation').toString()}
                    maxLength={2}
                    minLength={2}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="districtName">
                  <Translate id="account.register.districtName" />
                </label>
                {this.props.form.getFieldDecorator('districtName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.districtName').toString()}
                    placeholder={this.props.translate('account.register.districtName').toString()}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="schoolName">
                  <Translate id="account.register.schoolName" />
                </label>
                {this.props.form.getFieldDecorator('schoolName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.schoolName').toString()}
                    placeholder={this.props.translate('account.register.schoolName').toString()}
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="cultureId">
                  <Translate id="account.register.culture" />
                </label>
                {this.props.form.getFieldDecorator('cultureId', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Select allowClear={true} placeholder="Please select culture" size="large" tabIndex={1}>
                    {this.generateLanguageOptions()}
                  </Select>
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="gradeId">
                  <Translate id="account.register.gradeLevel" />
                </label>
                {this.props.form.getFieldDecorator('gradeId', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Select optionFilterProp="title" placeholder="Please select grade" size="large" tabIndex={1}>
                    {Grades.All.map(x => (
                      <Select.Option key={`grade${x.id}`} value={x.id}>
                        {x.shortName}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="password">
                  <Translate id="account.register.password" />
                </label>
                {this.props.form.getFieldDecorator('password', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.password').toString()}
                    placeholder={this.props.translate('account.register.password').toString()}
                    type="password"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="confirmPassword">
                  <Translate id="account.register.confirmPassword" />
                </label>
                {this.props.form.getFieldDecorator('confirmPassword', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    tabIndex={1}
                    size="large"
                    aria-label={this.props.translate('account.register.confirmPassword').toString()}
                    placeholder={this.props.translate('account.register.confirmPassword').toString()}
                    type="password"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Button tabIndex={1} loading={this.props.User.state === 'loading'} size="large" type="primary" htmlType="submit">
                  {this.props.User.state !== 'loading' && this.props.translate('account.register.registerButton')}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }

  private generateLanguageOptions() {
    // Only available languages
    return Languages.All.filter(x => x.isAvailable && x.code !=='en-au').map(x => (
      <Select.Option key={`cultureIds${x.id}`} value={x.id}>
        {x.name} ({x.code})
      </Select.Option>
    ));
  }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    register: (registerModel: RegisterDTO) => UserAction.Register(dispatch, registerModel),
    updateUserError: (msg: string) => updateUserError(dispatch, msg),
    clearPreviousLocation: () => ConfigAction.SetPreviousLocation(dispatch, null)
  };
}

function mapStateToProps(state: ReduxStoreModel) {
  return {
    User: state.User,
    Constants: state.Constants,
    Config: state.Config
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Form.create()(Register)));



// WEBPACK FOOTER //
// ./src/pages/account/Register.tsx